module.exports = __webpack_public_path__ + "static/media/PO.2cda8837.svg";